module.exports = __webpack_public_path__ + "img/logo.b1bc62f6.png";